import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDStack } from '@facet-wealth/design';
import fr from 'facet-rest';
import { ImageRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ImageRel';
import PropTypes from 'prop-types';
import { LottieRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/LottieRel';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import WelcomeInfoTitleAndSubtitle
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/WelcomeRework/WelcomeTitleAndSubtitle';


function WelcomeInfoLayoutDefault({ isImageAtTop }) {
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  const MediaSection = (
    <LottieLoadingLayout>
      {resource.withRelationship(fr.relationships.lottie.name,
        (rel) => <LottieRel relationship={rel} />,
        () => null)}
      {resource.withRelationship(fr.relationships.image.name,
        (rel) => <ImageRel relationship={rel} rounded={false} />,
        () => null)}
    </LottieLoadingLayout>
  );

  return (
    <FDStack direction={'column'} spacing={5} alignItems={'center'}>
      {isImageAtTop ? MediaSection : null }
      <WelcomeInfoTitleAndSubtitle title={resource.attr('title')} subtitle={resource.attr('subtitle')} />
      <MetaControlField attr={'description'} simpleRootStyle />
      {!isImageAtTop ? MediaSection : null }
      <SurveyStepFooter
        onSubmit={onSubmitMetaForm}
        NextButtonProps={{
          buttonLabel: 'Continue',
        }}
      />
    </FDStack>
  );
}

WelcomeInfoLayoutDefault.propTypes = {
  isImageAtTop: true,
};

WelcomeInfoLayoutDefault.defaultProps = {
  isImageAtTop: PropTypes.bool,
};

export default WelcomeInfoLayoutDefault;
